import { Controller } from '@hotwired/stimulus'
import dialogPolyfill from 'dialog-polyfill'
import { waitForAnimations } from '../utils'

// Connects to data-controller="dialog"
export default class extends Controller {
  static targets = ['dialog', 'animationsHolder', 'overlay']

  static values = {
    open: { type: Boolean, default: false },
  }

  initialize() {
    dialogPolyfill.registerDialog(this.dialogTarget)
  }

  connect() {
    if (this.openValue) {
      this.show()
    }

    document.addEventListener('turbo:before-render', this.#forceClose)
    this.dialogTarget.addEventListener('cancel', this.#cancel)
  }

  disconnect() {
    document.removeEventListener('turbo:before-render', this.#forceClose)
    this.dialogTarget.removeEventListener('cancel', this.#cancel)
  }

  closeTargetConnected(element) {
    this.close()
    element.remove()
  }

  show(_event) {
    this.dialogTarget.showModal()
    // Retirer le focus automatique
    document.activeElement?.blur()
  }

  // The user turning the dialog down (cross, backdrop, Escape, Android back gesture):
  // `dialog:dismiss` tells it from a closing that follows an action inside the dialog
  // or a Turbo visit leaving the page, which go through close().
  dismiss() {
    this.dispatch('dismiss')
    this.close()
  }

  close() {
    this.dialogTarget.setAttribute('closing', '')
    Promise.all([
      this.hasOverlayTarget ? waitForAnimations(this.overlayTarget) : Promise.resolve(),
      waitForAnimations(this.animationsHolderTarget),
    ]).then(() => {
      this.dialogTarget.removeAttribute('closing')
      this.dialogTarget.close()
    })
  }

  backdropClose(event) {
    if (event.target === this.dialogTarget) {
      this.dismiss()
    }
  }

  // Escape and the Android back gesture reach the <dialog> as a native `cancel`, wherever the
  // focus is: dismiss it ourselves, with the closing animation, instead of the browser.
  #cancel = (event) => {
    event.preventDefault()
    this.dismiss()
  }

  #forceClose = () => {
    this.dialogTarget.close()
  }

  get #isOpen() {
    return this.dialogTarget.hasAttribute('open')
  }
}
